import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';

import { TdHighlightComponent } from './highlight.component';
export class QuiverHighlightModule {

static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
  imports: [
    CommonModule,
  ],
  declarations: [
    TdHighlightComponent,
  ],
  exports: [
    TdHighlightComponent,
  ],
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function QuiverHighlightModule_tsickle_Closure_declarations() {
/** @type {?} */
QuiverHighlightModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
QuiverHighlightModule.ctorParameters;
}

interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
